// Convert provided string to sentence case.
function toTitleCase(str) {
  return str
    .toLowerCase()
    .replace(/\.\s*([a-z])|^[a-z]/gm, (s) => s.toUpperCase());
}

// Add your own names here to override to lower case
function toLowerCaseNames(str) {
  return str.replace(
    /\b(lower case example 1|lower case example 2)\b/gim,
    (s) => s.toLowerCase(),
  );
}

// Add your own names here to override to UPPER CASE
function toUpperCaseNames(str) {
  return str.replace(/\b(hello|string)\b/gim, (s) => s.toUpperCase());
}

export default function toSentenceCase(str) {
  return toLowerCaseNames(toUpperCaseNames(toTitleCase(str)));
}
